import ApiService from './ApiService';


class SmartSearchService extends ApiService{
    constructor() {
        super();
        this._searchUrl = '/smart-search';
        this._locale = 'ru';
    }

    getSearchResult(searchString) {
        const params = {search: searchString};
        const headers = this.getLangHeader();
        return this.postResource(this._searchUrl, params, headers);
    }
}

const smartSearchService = new SmartSearchService();

export default smartSearchService;
